import { render, staticRenderFns } from "./main-nav.vue?vue&type=template&id=067c0dd8&scoped=true&"
import script from "./main-nav.vue?vue&type=script&lang=js&"
export * from "./main-nav.vue?vue&type=script&lang=js&"
import style0 from "./main-nav.vue?vue&type=style&index=0&id=067c0dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c0dd8",
  null
  
)

export default component.exports